document.addEventListener('click',function(event){const toggle=event.target.closest('.menu-toggle');if(toggle){const menu=document.getElementById(toggle.getAttribute('aria-controls'));const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;}if(event.target.closest('#mobile-menu a')){document.getElementById('mobile-menu').hidden=true;document.querySelector('.menu-toggle').setAttribute('aria-expanded','false');}});document.addEventListener('keydown',function(event){if(event.key==='Escape'){const menu=document.getElementById('mobile-menu');if(menu&&!menu.hidden){menu.hidden=true;const b=document.querySelector('.menu-toggle');b.setAttribute('aria-expanded','false');b.focus();}}});document.addEventListener('change',function(event){if(event.target.matches('[data-variant-select]')){const selected=event.target.selectedOptions[0];const form=event.target.closest('form');const button=form.querySelector('[name=add]');const unavailable=selected.dataset.available!=='true';button.disabled=unavailable;button.textContent=unavailable?'Indisponible':'Ajouter au panier';const price=document.getElementById('ProductPrice');if(price)price.textContent=selected.dataset.price;}});

document.addEventListener('submit',async function(event){
  const offerForm=event.target.closest('[data-second-product-form]');
  if(!offerForm)return;
  event.preventDefault();

  const mainForm=document.getElementById('MainProductForm');
  const currentVariant=mainForm&&mainForm.querySelector('[name="id"]');
  const secondVariant=offerForm.querySelector('[name="second_variant_id"]');
  const button=offerForm.querySelector('button[type="submit"]');
  const status=offerForm.querySelector('[data-second-product-status]');

  if(!currentVariant||!secondVariant||!secondVariant.value){
    status.textContent='Choisis d’abord ton deuxième produit.';
    return;
  }

  button.disabled=true;
  button.textContent='Ajout en cours…';
  status.textContent='';

  try{
    const response=await fetch(offerForm.dataset.cartAddUrl,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[
        {id:Number(currentVariant.value),quantity:1},
        {id:Number(secondVariant.value),quantity:1}
      ]})
    });
    if(!response.ok){
      const error=await response.json().catch(function(){return {};});
      throw new Error(error.description||'Impossible d’ajouter les produits.');
    }
    window.location.href=offerForm.dataset.cartUrl;
  }catch(error){
    status.textContent=error.message||'Une erreur est survenue. Réessaie.';
    button.disabled=false;
    button.innerHTML='Ajouter les 2 au panier <span class="arrow-icon" aria-hidden="true"></span>';
  }
});
